import React from 'react';

import DefaultImg from '@/pages/opinion/assets/imgs/trends-default-img.jpg';

import './index.scss';
import RenderImg from '@/pages/opinion/components/RenderImg';
import DOMPurify from 'dompurify';

export default function NewsBox({
  newsImg,
  newsTitle,
  newsMedia,
  onClick,
}: any) {
  return (
    <div className="dbo-newsbox" onClick={onClick}>
      {newsImg != '' ? (
        <RenderImg
          defaultImage={DefaultImg}
          className="dbo-newsbox-img"
          coverImage={newsImg}
        />
      ) : null}
      <div className="dbo-newsbox-des">
        <span
          className="dbo-newsbox-des-tit"
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(newsTitle),
          }}
        ></span>
        {newsMedia ? (
          <span
            className="dbo-newsbox-des-text"
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(newsMedia),
            }}
          ></span>
        ) : null}
      </div>
    </div>
  );
}
